/**
 * Currency Definitions
 * Defines formatting rules for different currencies
 */

export const currencies = {
    SEK: {
        code: 'SEK',
        symbol: 'kr',
        symbolPosition: 'after',  // before or after
        decimalSeparator: ',',
        thousandSeparator: ' ',
        decimals: 2
    },
    EUR: {
        code: 'EUR',
        symbol: '€',
        symbolPosition: 'after',
        decimalSeparator: ',',
        thousandSeparator: ' ',
        decimals: 2
    },
    USD: {
        code: 'USD',
        symbol: '$',
        symbolPosition: 'before',
        decimalSeparator: '.',
        thousandSeparator: ',',
        decimals: 2
    },
    NOK: {
        code: 'NOK',
        symbol: 'kr',
        symbolPosition: 'after',
        decimalSeparator: ',',
        thousandSeparator: ' ',
        decimals: 2
    },
    DKK: {
        code: 'DKK',
        symbol: 'kr',
        symbolPosition: 'after',
        decimalSeparator: ',',
        thousandSeparator: ' ',
        decimals: 2
    },
    GBP: {
        code: 'GBP',
        symbol: '£',
        symbolPosition: 'before',
        decimalSeparator: '.',
        thousandSeparator: ',',
        decimals: 2
    }
};

/**
 * Get currency configuration by code
 * @param {string} currencyCode - Currency code (e.g., 'SEK', 'EUR')
 * @returns {Object} Currency configuration
 */
export function getCurrency(currencyCode) {
    return currencies[currencyCode] || currencies.SEK;
}
